import * as constants from '../constants/departments';
import {pagination} from '../../config/settings';
import * as _ from 'lodash';

export const initialState = {
  item: null,
  list: [],
  totalCount: 0,
  loading: false,
  params: {
    ordering: 'id', limit: pagination.limit, offset: 0, search: null
  },
  selected: [],
  pagesCount: 1,
  page: 1,
};

export default (state = _.cloneDeep(initialState), action) => {
  if (action.second) {
    return state;
  }

  switch (action.type) {
    case constants.GET_DEPARTMENTS:
    case constants.GET_DEPARTMENT:
    case constants.UPDATE_DEPARTMENT:
    case constants.REMOVE_DEPARTMENT:
      return {
        ...state,
        loading: true
      };

    case constants.GET_DEPARTMENTS_ERROR:
    case constants.GET_DEPARTMENT_ERROR:
    case constants.UPDATE_DEPARTMENT_ERROR:
    case constants.REMOVE_DEPARTMENT_ERROR:
      return {
        ...state,
        loading: false,
        clearing: false,
      };

    case constants.GET_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        clearing: false,
        list: action.payload,
        item: null,
        totalCount: action.totalCount,
        pagesCount: Math.ceil(action.totalCount / pagination.limit)
      };

    case constants.GET_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        list: [],
        item: action.payload,
      };

    case constants.EDIT_DEPARTMENT:
      return {
        ...state,
        item: action.data,
      };
    case constants.DEPARTMENTS_CHANGE_PARAMS:
      return {
        ...state,
        params: action.data,
      };

    case constants.DEPARTMENTS_UPDATE_PARAMS:
      return {
        ...state,
        params: action.data !== null ? _.merge(state.params, action.data) : _.cloneDeep(initialState.params)
      };

    case constants.DEPARTMENTS_RESET_PARAMS:
      return {
        ...state,
        clearing: false,
        paramsChanged: false,
        params: _.cloneDeep(initialState.params)
      };
    case constants.DEPARTMENTS_CHANGE_PAGE:
      return {
        ...state,
        page: +action.data,
      };
    case constants.SELECT_DEPARTMENTS:
      return {
        ...state,
        selected: action.data,
      };
    case constants.UNSELECT_DEPARTMENTS:
      return {
        ...state,
        selected: [],
      };

    case constants.DEPARTMENTS_CLEAR:
      return {
        ...state,
        clearing: true,
        totalCount: 0,
        pagesCount: 1,
        page: 1,
        item: null,
        list: [],
        selected: [],
      };


    default:
      return state;
  }
};